import ShareLinksTable from "./ShareLinksTable";
import "./share.scss";

/**
 * Settings, Site tab: the replay clips shared from this website, and how to make one. A clip is of one site, so it is here; the demo has no Site tab and nothing to keep, so it does not show this at all. Styled as
 * the tab's own cards (the "subscription-details" heading and note, then a table).
 */
const ShareSettingsSection = () => (
  <div className="row share-settings-row">
    <div className="col-12">
      <div className="subscription-details share-settings" data-share-settings>
        <h4>Replay clips</h4>
        <p className="pv-breakdown-note">
          Short replays of your visitors that you have shared by link. Anyone with the link can watch without an account. A link stops working on its date unless you renew it, and you can turn it off at any time.
          To make one, open a playback, press <b>+</b> and choose <b>Share a replay clip</b>.
        </p>
        <ShareLinksTable />
      </div>
    </div>
  </div>
);

export default ShareSettingsSection;
